import React from "react";
import { Outlet } from "react-router-dom";
import { DocsSidebar } from "./DocsSidebar";
import { DocsTopNav } from "./DocsTopNav";
import { DocsMobileNav } from "./DocsMobileNav";
import { cn } from "../../../lib/utils";
import {
  ContentPage,
  getContentIndexAsync,
} from "../../../utils/docs/contentLoader";

interface DocsLayoutProps {
  className?: string;
}

export function DocsLayout({ className }: DocsLayoutProps) {
  const [pages, setPages] = React.useState<ContentPage[]>([]);

  React.useEffect(() => {
    // Load content index to get pages for search
    getContentIndexAsync().then((index) => {
      // Filter to only show integrations section pages
      // TODO: Remove this filter when other sections are ready
      const filteredPages = index.pages.filter(
        (page) => page.section === "integrations",
      );
      setPages(filteredPages);
    });
  }, []);

  return (
    <div
      className={cn(
        "min-h-screen bg-[var(--su-bg-primary)] flex flex-col",
        className,
      )}
    >
      <DocsTopNav pages={pages} />
      <DocsMobileNav />
      <div className="flex flex-1">
        <DocsSidebar />
        <main className="flex-1 min-w-0">
          <div className="max-w-4xl mx-auto px-4 md:px-8 py-8">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
